import React from "react";
import redSmile from "../../../images/smileRed.svg";
import Image from "next/image";
import styles from "./MinAndMaxWidthAlert.module.css";
import cx from "classnames";

const MinAndMaxWidthAlert = () => {
  return (
    <div
      className={cx(
        styles.container,
        "flex-column",
        "align-items-center",
        "justify-content-center"
      )}
    >
      {/* <Image alt="about digikala" src={redSmile} width="100%" height="100%" /> */}
      <svg
        width="32"
        height="12"
        viewBox="0 0 32 12"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M31.7133 4.81373C27.8179 9.23004 22.213 11.998 15.9871 11.998C9.76116 11.998 4.18297 9.24159 0.28759 4.83913C-0.113078 4.38664 -0.0908188 3.68253 0.327656 3.24851L3.0611 0.415885C3.51297 -0.0527564 4.2542 -0.0319791 4.67935 0.466674C7.43506 3.69407 11.4573 5.72793 15.9403 5.72793C20.4234 5.72793 24.508 3.66175 27.2637 0.3928C27.6866 -0.108162 28.4301 -0.133557 28.8864 0.337394L31.671 3.22543C32.0895 3.65944 32.1117 4.36125 31.7133 4.81373Z"
          fill="white"
        />
      </svg>

      <p className="mt-3">
        برای تجربه بهتر در این وبسایت، لطفا از صفحه نمایش بزرگتر استفاده کنید.
      </p>
    </div>
  );
};

export default MinAndMaxWidthAlert;
